import React, { useState } from 'react';
import Autosuggest from 'react-autosuggest';
import { getUserlist } from '../../services/api';

const FilterBox = ({ onFilterApply }) => {
  const [filters, setFilters] = useState({
    dateFrom: '',
    dateTo: '',
    user_id: '',
    rewardName: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleApplyFilters = () => {
    onFilterApply(filters);
  };

  const handleResetFilters = () => {
    setValue('')
    setFilters({
      dateFrom: '',
      dateTo: '',
      user_id: '',
      rewardName: ''
    });
    onFilterApply({
      dateFrom: '',
      dateTo: '',
      user_id: '',
      rewardName: ''
    });
  };

  const [suggestionsCard, setSuggestionsCard] = useState([]);
  const [value, setValue] = useState('');
  const fetchSuggestions = async ({ value }) => {
    if (!value) return setSuggestionsCard([]);

    try {

      const response = await getUserlist(25, 1, value);
      const data = await response.data;
      setSuggestionsCard(data.data || data);
    } catch (error) {
      console.error('Error fetching suggestions:', error);
      setSuggestionsCard([]);
    }
  };

  const onSuggestionsFetchRequested = ({ value }) => fetchSuggestions({ value });
  const onSuggestionsClearRequested = () => setSuggestionsCard([]);

  const getSuggestionValue = suggestion => `${suggestion.fname} ${suggestion.lname} (${suggestion.email})`;
  const renderSuggestion = suggestion => (
    <div className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-sm">
      {suggestion.fname} {suggestion.lname} ({suggestion.email})
    </div>
  );
  const setSelectedCardId = (card_id) => {
    setFilters(prev => ({
      ...prev,
      ['user_id']: card_id
    }));
  }

  return (
    <div className="bg-white p-4 rounded-lg shadow-md mb-6">
      {/* <h2 className="text-lg font-semibold text-gray-800 mb-4">Filter Options</h2> */}

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {/* Date Range Filter */}


        {/* Customer Name Filter */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Customer Name</label>
          <Autosuggest
            disabled
            suggestions={suggestionsCard}
            onSuggestionsFetchRequested={onSuggestionsFetchRequested}
            onSuggestionsClearRequested={onSuggestionsClearRequested}
            getSuggestionValue={getSuggestionValue}
            onSuggestionSelected={(_, { suggestion }) => {
              setSelectedCardId(suggestion.id); // Capture the card_id
            }}
            renderSuggestion={renderSuggestion}
            inputProps={{
              placeholder: 'Type to name,email,mobile',
              value,
              onChange: (_, { newValue }) => setValue(newValue),
              className: 'w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500'
            }}
            theme={{
              container: 'relative',
              suggestionsContainer:
                'absolute z-50 w-full bg-white border border-gray-200 rounded  max-h-60 overflow-y-auto',
              suggestionsList: 'm-0 p-0 list-none',
              suggestion: '',
              suggestionHighlighted: 'bg-blue-100'
            }}
          />
          {/* <input
            type="text"
            name="customerName"
            value={filters.customerName}
            onChange={handleInputChange}
            placeholder="Enter customer name"
            className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          /> */}
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Date From</label>
          <input
            type="date"
            name="dateFrom"
            value={filters.dateFrom}
            onChange={handleInputChange}
            className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Date To</label>
          <input
            type="date"
            name="dateTo"
            value={filters.dateTo}
            onChange={handleInputChange}
            className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>

        {/* Reward Name Filter */}
        {/* <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Reward Name</label>
          <input
            type="text"
            name="rewardName"
            value={filters.rewardName}
            onChange={handleInputChange}
            placeholder="Enter reward name"
            className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div> */}
      </div>

      <div className="flex justify-end mt-4 space-x-3">
        <button
          onClick={handleResetFilters}
          className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition-colors"
        >
          Reset
        </button>
        <button
          onClick={handleApplyFilters}
          className="px-4 py-2 bg-[#f4a406] text-white rounded-md hover:bg-[#d89005] transition-colors"
        >
          Apply Filters
        </button>
      </div>
    </div>
  );
};

export default FilterBox;